import { render, staticRenderFns } from "./SubNavbar.vue?vue&type=template&id=666634d5&scoped=true&"
import script from "./SubNavbar.vue?vue&type=script&lang=js&"
export * from "./SubNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SubNavbar.vue?vue&type=style&index=0&id=666634d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666634d5",
  null
  
)

export default component.exports